import React from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Link } from "react-router-dom";

const NotificationDropdown = () => {
  return (
    <Popover>
      <PopoverButton className="block focus:outline-none text-gray-600 data-[hover]:text-gray-400 data-[focus]:outline-1 data-[focus]:outline-gray-100">
        <i className="fas fa-bell text-xl"></i>
      </PopoverButton>
      <PopoverPanel
        transition
        anchor="bottom"
        className="divide-y divide-white/5 rounded-xl bg-gray-700 text-sm/6 transition duration-200 ease-in-out [--anchor-gap:var(--spacing-5)] data-[closed]:-translate-y-1 data-[closed]:opacity-0 z-20"
      >
        <div className="p-3">
          <Link
            className="block rounded-lg py-2 px-3 transition hover:bg-white/5"
            to="#"
          >
            <p className="font-semibold text-white">Insights</p>
            <p className="text-white/50">Measure actions your users take</p>
          </Link>
          <Link
            className="block rounded-lg py-2 px-3 transition hover:bg-white/5"
            to="#"
          >
            <p className="font-semibold text-white">Automations</p>
            <p className="text-white/50">Create your own targeted content</p>
          </Link>
          <Link
            className="block rounded-lg py-2 px-3 transition hover:bg-white/5"
            to="#"
          >
            <p className="font-semibold text-white">Reports</p>
            <p className="text-white/50">Keep track of your growth</p>
          </Link>
        </div>
        <div className="p-3">
          <Link
            className="block rounded-lg py-2 px-3 transition hover:bg-white/5"
            to="#"
          >
            <p className="font-semibold text-white">Documentation</p>
            <p className="text-white/50">
              Start integrating products and tools
            </p>
          </Link>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default NotificationDropdown;
